import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {gqlStatusMessage, StatusMessage} from '../../graphql/common.datatypes';
import {clearCache} from '../../graphql/GraphQlProvider';

const LOGOUT_MUTATION = gql`
    mutation logoutUser {
        logout {
            ${gqlStatusMessage}
        }
    }
`;

interface LogOutData {
  logout: StatusMessage
}

export const logoutUser = () => useMutation<LogOutData>(
  LOGOUT_MUTATION,
  {
    onCompleted: () => {
      clearCache();
    }
  }
);

export default logoutUser;
